<template>
  <div class="publish">
    <header>
      <div class="title" :class="{isActive: pageIndex === 0}" @click="togglePage(0)">公众号管理</div>
      <div class="title" :class="{isActive: pageIndex === 1}" @click="togglePage(1)">图文</div>
      <div class="title" :class="{isActive: pageIndex === 2}" @click="togglePage(2)">
        推送
        <el-badge :value="propellingNum" overflow-count="99" v-if="propellingNum>0"></el-badge>
      </div>
    </header>
    <div class="publish-content">
      <!--公众号管理模块-->
      <setting v-if="pageIndex === 0"></setting>
      <!--图文模块-->
      <img-text v-if="pageIndex === 1"></img-text>
      <!--推送模块-->
      <article-send v-if="pageIndex === 2"></article-send>
    </div>
  </div>
</template>

<script>
import api from "@/api/news/publish.js";
import setting from "./setting/index";
import imgText from "./imgText/index";
import articleSend from "./send/index";
export default {
  components: {
    setting,
    articleSend,
    imgText
  },
  data() {
    return {
      pageIndex: 1
    };
  },
  computed: {
    propellingNum() {
      return this.$store.state.sendList.length;
    },
    userInfo() {
      return this.$store.state.userInfo;
    }
  },
  created() {
    if (this.$route.query.auth_code) {
      this.initwechat();
    } else {
      this.getArticleManager();
    }
  },
  methods: {
    togglePage(index) {
      this.pageIndex = index;
    },
    async getArticleManager() {
      let data = {
        communityid: this.userInfo.communityId
      };
      let res = await this.$http.get(api.sendArticleManager, { params: data });
      if (res && res.isSucceed) {
        this.$store.commit("SET_COMMUNITY",res.rows&&res.rows.length>0? res.rows[0]:{});
      }
    },
    async initwechat() {
      let data = {
        authorization_code: this.$route.query.auth_code,
        orgid: this.userInfo.communityId,
      };
      let res = await this.$http.get(api.initWechat, { params: data });
      if (res && res.isSucceed) {
        this.$store.commit("SET_COMMUNITY", res.rows&&res.rows.length>0? res.rows[0]:{});
      }
    }
  }
};
</script>

<style lang='less' scoped>
.publish {
  width: 100%;
  height: 100%;
  header {
    width: 100%;
    min-width: 1000px;
    height: 60px;
    line-height: 60px;
    background-color: #fff;
    text-align: center;
    border-bottom: 1px solid #dfdfdf;
    box-shadow: 6px 0px 10px rgba(167, 176, 194, 0.3);
    .title {
      display: inline-block;
      margin: 0 20px;
      font-size: 18px;
      line-height: 55px;
      cursor: pointer;
    }
    .isActive {
      color: #009688;
      border-bottom: 2px solid #009688;
    }
  }
  .publish-content {
    width: 100%;
    height: calc(100% - 60px);
  }
}
</style>


